import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Badge from "@material-ui/core/Badge";
import axios from "axios";
import { connect } from "react-redux";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import LinearProgress from "@material-ui/core/LinearProgress";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";
import AdvancedSearch from "./AdvanceSearch";
import logo from "../lib/logo.png";
// import logo from '../lib/logo_init.png';
import { useSelector, useDispatch } from "react-redux";
import { filterData, defaultFilters, allWebURLData, updateFilterField} from "../redux/actions";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#091F2F",
    },
    secondary: {
      main: "#1871BD",
      contrastText: "#ffffff",
    },
  },
  typography: {
    // fontFamily: ['Montserrat', 'serif'].join(','), Uncomment if you want all the typography to inherit this font.
    a: {
      fontFamily: ["Montserrat", "serif"].join(","),
      fontSize: 16,
      fontWeight: 400,
    },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: 65,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "flex",
    },
  },
  filter: {
    left: 5,
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    marginRight: 10,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing.unit,
      width: "auto",
    },
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200,
      },
    },
  },
  progress: {
    // top: 64,
    zIndex: 1101,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  formControl: {
    margin: theme.spacing.unit,
    marginLeft: 0,
    minWidth: 120,
  },
}));

const StyledBadge = withStyles((theme) => ({
  badge: {
    right: -5,
    top: 2,
    // border: `1px solid ${theme.palette.background.paper}`,
    // padding: '0 4px',
  },
}))(Badge);

const SearchAppBar = (props) => {
  const classes = useStyles();
  let [open, setOpen] = useState(false);
  let [searchText, setSearchText] = useState("");
  let [filterCount, setFilterCount] = useState(0);

  // let [showProgress, setShowProgress] = useState(true);

  const showProgress = useSelector((state) => state.showProgress);
  const filters = useSelector((state) => state.filters);
  const neighborhood = useSelector((state) => state.filters.neighborhoodValue);
  const project = useSelector((state) => state.filters.projId);
  const document = useSelector((state) => state.filters.docTypeValue);
  const startDate = useSelector((state) => state.filters.startDate);
  const endDate = useSelector((state) => state.filters.endDate);

  const dispatch = useDispatch();

  let handleClick = () => {
    setOpen(!open);
  };
  let handleKeyPress = (event) => {
    var code = event.keyCode || event.which;
    //
    if (code === 13) {
     dispatch(updateFilterField('searchText', event.target.value));
    }
  };

  let handleChange = (event) => {
    setSearchText(event.target.value);
  };

  let handleBlur = () => {
    if (searchText.length > 2)
    { 
      dispatch(
        updateFilterField({
          searchText: searchText,
          startDate: startDate,
          endDate: endDate,
          docTypeValue: document,
          neighborhoodValue: neighborhood,
          projId: project,
          page: 1,
          pageMarker: {},
        })
      );
    }
    // this.dispatchFilters(searchText)
  };
  useEffect(() => {
    let count = 0;
    if (filters !== "") {
      for (const [key, value] of Object.entries(filters)) {
        if (value !== undefined && key !== "page" && key !== "pageMarker") {
          count++;
        }
      }
      setFilterCount(count);
    }
  }, [filters]);

  useEffect(() => {
  const fetchFilters = async () => {
    try {
      const [neighborhoodRes, docTypeRes, projectRes, webUrlRes] = await Promise.all([
        axios.get("https://sire.bostonplans.org/api/documentSearch/getNeighborhoods"),
        axios.get("https://sire.bostonplans.org/api/documentSearch/getDocumentTypes"),
        axios.get("https://sire.bostonplans.org/api/documentSearch/getProjects"),
        axios.get("https://sire.bostonplans.org/api/documentSearch/getWebsiteURL"),
      ]);

      const allNeighborhoods = neighborhoodRes.data
        .filter((entry) => entry.Neighborhood__c)
        .map((entry) => ({ name: entry.Neighborhood__c }));

      const allDocumentTypes = docTypeRes.data
        .filter((entry) => entry)
        .map((entry) => ({ name: entry }));
      const allProjectNames = projectRes.data.map((entry) => ({
        id: entry.Id,
        name: entry.Name,
        url: entry.Website_URL__c,
      }));

      const allWebURLs = webUrlRes.data.map((entry) => ({
        id: entry.Id,
        url: entry.Website_URL__c,
      }));
      // Dispatch once all data is ready
      dispatch(
        defaultFilters({
          uniqueNeighborhood: allNeighborhoods.sort((a, b) => a.name.localeCompare(b.name)),
          uniqueDocumentTypes: allDocumentTypes.sort((a, b) => a.name.localeCompare(b.name)),
          uniqueProjectNames: allProjectNames.sort((a, b) => a.name.localeCompare(b.name)),
        })
      );

      dispatch(allWebURLData(allWebURLs));
    } catch (error) {
      console.error("Error loading filter lists:", error);
    }
  };

  fetchFilters();
}, []);

  return (
    <MuiThemeProvider theme={theme}>
      <div className={classes.root}>
        <AppBar position="static">
          <Toolbar style={{ paddingRight: 0 }}>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
            >
              <img src={logo} alt="Logo" style={{ height: 40 }} />
            </IconButton>
            <Typography
              variant="h6"
              color="inherit"
              className={classes.sectionDesktop}
              noWrap
            >
              ARTICLE 80 RECORDS LIBRARY
            </Typography>
            <div className={classes.grow} />
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <InputBase
                placeholder="Search…"
                classes={{
                  root: classes.inputRoot,
                  input: classes.inputInput,
                }}
                onKeyPress={handleKeyPress}
                onChange={handleChange}
                onBlur={handleBlur}
                value={searchText}
              />
            </div>

            <Button color="inherit" onClick={handleClick}>
              <StyledBadge color="secondary">
                Filters
              </StyledBadge>
            </Button>

            <IconButton color="inherit" onClick={handleClick}>
              {!open ? <ExpandMoreIcon /> : <CloseIcon />}
            </IconButton>
          </Toolbar>
        </AppBar>
        {showProgress && (
          <LinearProgress color="secondary" className={classes.progress} />
        )}
        {open ? <AdvancedSearch /> : null}
      </div>
    </MuiThemeProvider>
  );
};
const mapStateToProps = (state) => ({
  filters: state.filters,
  data: state.data,
  pageMarker: state.filters.pageMarker,
  page: state.filters.page,
  allWebURL: state.allWebURL,
  totalDocCount: state.totalDocCount,
});
export default (connect(mapStateToProps)(SearchAppBar));

// export default SearchAppBar;
